jQuery(document).ready(function() {
    jQuery('.subscribe-modal').on( 'click', function(){
        jQuery('#subscribe-modal').foundation('open');
    });
});